<template>
    <tr>
        <slot />
    </tr>
</template>

<script setup>
defineOptions({
    name: 'ZenGridFooterRow',
})
</script>
